<template>
  <div class="services-wrapper">
    <custom-result-not-found
      v-if="!services.length"
      text="No cuenta con información disponible."
    />
    <template v-else>
      <div
        v-for="(service, idx) of services"
        :key="`service-${idx}`"
        class="row mx-0 bg-secondary-3 p-3 mt-3 rounded"
      >
        <div class="col-12 col-md-3 mb-3 mb-md-0">
          <span class="data-title">
            Fecha:
          </span>
          <span class="label">
            {{ service.serviceDate | date }}
          </span>
        </div>
        <div class="col-12 col-md-3 mb-3 mb-md-0">
          <span class="data-title">
            Horario:
          </span>
          <span class="label">
            {{ service.serviceTime }}
          </span>
        </div>
        <div class="col-12 col-md-3 mb-3 mb-md-0">
          <span class="data-title">
            Tipo:
          </span>
          <span class="label font-weight-bold">
            {{ service.serviceType }}
          </span>
        </div>
        <div class="col-12 col-md-3 mb-3 mb-md-0">
          <span class="data-title">
            Asistente de servicio:
          </span>
          <span class="label">
            {{ service.serviceAssistant }}
          </span>
        </div>
      </div>
      <pagination
        v-if="pagination.totalItemCount > pagination.perPage"
        :data="pagination"
        :page-size="pagination.perPage"
        @pagination-go-page="onPageChanged"
      />
    </template>
  </div>
</template>

<script>
import { getValidityServices } from '@/services/api/tapRequest.api.js';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination'

const DEFAULT_PAGE_SIZE = 10

export default {
  name: 'ValidityServices',
  components: { 
    CustomResultNotFound,
    Pagination
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
    academicYearId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    pagination: {
      perPage: DEFAULT_PAGE_SIZE,
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 0,
      count: 0,
    },
    services: [],
  }),
  async created() {    
    await this.searchServices(1);
  },
  methods: {
    async searchServices(page) {
      this.pagination.currentPage = page;

      const { data } = await getValidityServices({              
        tapRequestId: this.requestId,
        academicYearId: this.academicYearId,
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.perPage
      });      

      this.services = data.data

      this.pagination = {
          ...this.pagination,
          totalItemCount: data.totalItemCount,
          pageCount: data.pageCount,
          currentPage: data.currentPage,
          count: data.count,
        };
    },
    async onPageChanged(currentPage) {      
      await this.searchServices(currentPage);
    },
  },
};
</script>

<style lang="scss" scoped>
.services-wrapper {
  .label {
    margin: 0 !important;
  }
}
</style>
